import type { IntentActionType, IntentTemplate } from "../types";
import { APPOINTMENTS_INTENT_TEMPLATES } from "./appointments-intent-templates";
import { CONFIG_INTENT_TEMPLATES } from "./config-intent-templates";
import { CUSTOMERS_INTENT_TEMPLATES } from "./customers-intent-templates";
import { DISCOUNTS_INTENT_TEMPLATES } from "./discounts-intent-templates";
import { SERVICE_INTENT_TEMPLATES } from "./services-intent-templates";

export const INTENT_TEMPLATES: Record<IntentActionType, IntentTemplate> = {
  ...SERVICE_INTENT_TEMPLATES,
  ...CONFIG_INTENT_TEMPLATES,
  ...APPOINTMENTS_INTENT_TEMPLATES,
  ...CUSTOMERS_INTENT_TEMPLATES,
  ...DISCOUNTS_INTENT_TEMPLATES,
} as Record<IntentActionType, IntentTemplate>;
